export const splitStringToParts = (text: string, separator?: string | RegExp): string[] => {
    return (text ?? '')
        .trim()
        .split(separator ?? '\n')
        .map((w) => w.trim().replace(/^"(.*)"$/, '$1'))
        .filter((c) => c.length > 0);
};
